@import '../../../../../../constants/spacing.module.less';

.send-products-body {
  text-align: left;
  width: 100%;
}

.asn-form-container {
  gap: @space-24;
  width: 100%;
}

.section-title {
  margin-bottom: @space-16;
  font-weight: 600;
}

.try-again-btn {
  margin-top: @space-16;
}
